import React from 'react';
import useCrispEventsPublisher from '../../../thirdpartyscripts/crisp/crispEventsPublisher';
import useFacebookEventsPublisher from '../../../thirdpartyscripts/fbpixel/fbEventsPublisher';
import {
  UpdateProfileForm as BaseUpdateProfileForm
} from 'features/tasks-forms';


export default function UpdateProfileForm() {

  const crispEventsPublisher = useCrispEventsPublisher();
  const fbEventsPublisher = useFacebookEventsPublisher();

  return (
    <BaseUpdateProfileForm
      onAccountCompleted={async () => {
        await crispEventsPublisher.onSignUp();
        fbEventsPublisher.onSignUp();
      }}
    />
  );
}
